import {userInfo, userInfoDto, loginUserKey} from "./Config";
import {getLocalStorage} from "./CommonUtil";

export const getUserInfo = () => {
  let userInfoJsonStr = getLocalStorage(loginUserKey);
  debugger;
  if (null === userInfoJsonStr){
    console.log(-1,userInfoDto);
    return userInfoDto;
  }
  console.log(1,userInfoJsonStr);
  console.log(2,userInfoDto);
  console.log(3,this.userInfoDto);
  this.userInfoDto = JSON.parse(userInfoJsonStr);
  console.log(4,this.userInfoDto);
  console.log(5,userInfoDto);
  console.log(6,this.userInfo);
  console.log(7,userInfo);
  userInfo.username = this.userInfoDto.username;
  userInfo.id = this.userInfoDto.id;
  console.log(8,this.userInfo);
  console.log(9,userInfo);
  return userInfo;
};
export const getUserToken = () => {
  debugger;
  this.userInfoDto = getUserInfo();
  let token = getLocalStorage(this.userInfoDto.username + "-token");
  console.log(token);
  return token;
};



// WEBPACK FOOTER //
// ./src/utils/UserUtil.js